/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import ObjectTypeModel from 'cio/models/object-type';
import ObjectTypesService from 'cio/services/object-types';
import article from 'cio/utils/a';

interface Args {
  objectType: ObjectTypeModel;
  openRelationshipsModal: () => unknown;
}

export default class AddObjectDropdown extends Component<Args> {
  @service auth!: AuthService;
  @service objectTypes!: ObjectTypesService;

  get addObjectOptions() {
    return [
      {
        label: 'Import a CSV',
        link: {
          route: 'imports.new',
          query: {
            type: 'object',
            objectTypeId: this.args.objectType.id,
          },
        },
      },
      {
        label: `Add ${article(this.args.objectType.singularName)}`,
        disabled: !this.objectTypes.canConfigureObjects,
        link: {
          route: 'objects.type.new',
        },
        tooltip: {
          condition: !this.objectTypes.canConfigureObjects,
          content: 'Contact an Admin to access this feature.',
        },
      },
      ...(this.args.objectType.objectCount > 0 && this.objectTypes.canCreateRelationships
        ? [
            {
              label: 'Add Relationships',
              action: this.args.openRelationshipsModal,
            },
          ]
        : []),
    ];
  }
}
